import { render, staticRenderFns } from "./zxfwxq.vue?vue&type=template&id=5685c2fe&scoped=true&"
import script from "./zxfwxq.vue?vue&type=script&lang=js&"
export * from "./zxfwxq.vue?vue&type=script&lang=js&"
import style0 from "./zxfwxq.vue?vue&type=style&index=0&id=5685c2fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5685c2fe",
  null
  
)

export default component.exports